import { createSlice } from '@reduxjs/toolkit'
import { createUser, editUser, getAllUser, getUser } from '../../builders/userManagement/userManagement.builder'

const initialState = {
  userData: [],
  allUsersData: [],
  loading: null,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearExtraReducers: (state) => {
      state.loading = false
      state.userData = []
      state.allUsersData = []
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllUser.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getAllUser.fulfilled, (state, action) => {
      state.allUsersData = action.payload
      state.loading = false
    })
    builder.addCase(getAllUser.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getUser.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getUser.fulfilled, (state, action) => {
      state.userData = action.payload
      state.loading = false
    })
    builder.addCase(getUser.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(editUser.pending, (state) => {
      state.loading = true
    })
    builder.addCase(editUser.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(editUser.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(createUser.pending, (state) => {
      state.loading = true
    })
    builder.addCase(createUser.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(createUser.rejected, (state) => {
      state.loading = false
    })
  },
})

export const { userData, allUsersData, loading } = userSlice.actions

export default userSlice.reducer
